import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable, tap } from 'rxjs'
import { ClientEmailDto } from 'src/app/models/client-email/client-email-dto'
import { ApplicationInsightsService } from '../application-insights/application-insights.service'
import { ConfigService } from '../config/config.service'

// Story e9-1: a separate backend controller/service, not folded onto ClientService/ClientDto —
// only the Service Plan Stepper's review step needs this lookup (mirrors NdisPlanService's own
// precedent). Named ClientEmailService (not CaregiverContactService, this story's original name)
// per code review: the lookup reads the client contact's own email directly — there is no
// caregiver-contact entity or relationship involved, and the old name implied one that doesn't exist.
@Injectable({
  providedIn: 'root',
})
export class ClientEmailService {
  private readonly emailUrl =
    this.config.getSettings('webApi').baseUri + 'clientemail/email'

  constructor(
    private http: HttpClient,
    private appInsights: ApplicationInsightsService,
    private config: ConfigService,
  ) {}

  GetEmail(contactId: string): Observable<ClientEmailDto> {
    const params: Record<string, string> = { contactId: contactId }

    return this.http
      .get<ClientEmailDto>(this.emailUrl, { params: params })
      .pipe(
        map((response) => response as ClientEmailDto),
        tap((_) => this.appInsights.logEvent('Retrieved client email')),
        catchError(async (err) => {
          throw err
        }),
      )
  }
}
